// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"635f5f07","963":"00b3a671"}[chunkId] + ".chunk.js";
};